export default defineAppConfig({
  isMultiplatform: false,
  integrations: {
    crmUrl: undefined,
    apiUrl: undefined,
    ipxUrl: undefined,
  },
  appearance: {
    //TODO: fix default path to public
    favicon: '/img/logo-default.svg',
    //TODO: fix default path to public
    logo: '/img/logo-default.svg',
    //TODO: fix default path to public
    authBg: '/assets/img/pages/auth/bg.png',
    colorSchema: {
      textColor: '#1F163B',
      primaryColor: '#2D2D86',
      primaryHoverColor: '#1F163B',
      secondaryColor: '#F0494F',
      greenColor: '#17A61D',
      mainBackgroundColor: '#FFFFFF',
    }
  },
  debug: false,
  preferences: {
    carsSearchByVin: false as boolean,
    withManager: false as boolean,
  }
});

declare module "nuxt/schema" {
  interface AppConfigInput {
    isMultiplatform: boolean;
    integrations?: {
      crmUrl?: string,
      apiUrl?: string,
      ipxUrl?: string,
    };
    /** Theme configuration */
    appearance?: {
      favicon?: string;
      logo?: string;
      authBg?: string;
      colorSchema: Record<string, string>
    };
    debug: boolean;
    preferences: {
      carsSearchByVin: boolean;
      withManager: boolean;
    }
  }
}

// It is always important to ensure you import/export something when augmenting a type
export {};
